import { render } from "./Courrier.vue?vue&type=template&id=850e7832"
import script from "./Courrier.vue?vue&type=script&lang=js"
export * from "./Courrier.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__